import React, { Fragment } from "react";
import { Navbar as BSNavbar } from "react-bootstrap";
import { Button } from "../../Button";
import parseChildren from "../../utils/parseChildren";
import { classNames } from "../../utils/classNames";
import { useTranslation } from "../../hooks/useTranslation";
import { useStylesHook } from "../../hooks/useStylesHook";
export const HeaderNavigation = (props) => {
    const t = useTranslation();
    return (React.createElement(NavBar, { back: props?.back, ariaLabel: t("Page Actions and Navigation"), width: props?.width?.navigation },
        props?.tabs && React.createElement(NavTabs, null, props?.tabs),
        props?.navigation && (React.createElement(NavTabs, null,
            React.createElement(HeaderNavbar, { navigation: props?.navigation }))),
        props?.extra && (React.createElement(NavButtons, null,
            React.createElement("div", { className: `page-nav-extra` }, props?.extra)))));
};
export const HeaderNavbar = ({ navigation }) => {
    return (React.createElement(Fragment, null, navigation.map((item, i) => {
        if (item.hidden)
            return null;
        return (React.createElement(Fragment, { key: i },
            React.createElement(HeaderTab, { active: item.active, disabled: item.disabled }, item.link)));
    })));
};
export const HeaderTab = ({ children, active = false, disabled = false, key, }) => (React.createElement("div", { className: classNames("pagenav-link", active ? "active" : "", disabled ? "disabled" : ""), key: key, role: "menuitem", "aria-disabled": disabled },
    disabled && React.createElement("div", { className: "block-link" }),
    children));
const NavBar = ({ back, children, ariaLabel, width = "standard" }) => {
    const formChildren = parseChildren(children);
    const classes = useStylesHook({
        container: {
            "& .container-fluid": {
                paddingLeft: "8px!important",
                paddingRight: "8px!important",
            },
        },
    });
    const tabChildren = formChildren.findByType(NavTabs);
    const buttonChildren = formChildren.findByType(NavButtons);
    return (React.createElement(BSNavbar, { staticTop: true, className: classNames("page-nav", width === "full-width" ? classes.container : undefined), "aria-label": ariaLabel, role: "navigation", fluid: width === "full-width" },
        back && (React.createElement("div", { className: "page-nav-back" },
            React.createElement(Button, { label: back.label, icon: "chevron-left", onClick: back.onClick && back.onClick, disabled: back.disabled, id: back.id }))),
        React.createElement(BSNavbar.Collapse, null,
            tabChildren && tabChildren,
            buttonChildren && buttonChildren),
        (tabChildren || back || buttonChildren) && React.createElement(BSNavbar.Toggle, null)));
};
const NavButtons = ({ children }) => {
    return React.createElement(BSNavbar.Form, { pullRight: true }, children);
};
export const NavTabs = ({ children, className }) => {
    return (React.createElement("div", { role: "menubar", className: classNames("pagenav", className) }, children));
};
